// extracted by mini-css-extract-plugin
module.exports = {"contaier":"ShortcutsResultTitle_contaier__3Hu4P","title":"ShortcutsResultTitle_title__1A23_","unit":"ShortcutsResultTitle_unit__6tpPE"};